export default __webpack_public_path__ + "static/media/step2.6f88bd86.webp";